import _ from 'lodash';
import React from 'react';
import { inject, observer } from 'mobx-react';
import { NavLink } from 'react-router-dom';

@inject('artistStore')
@observer
class ArtistStatusFilter extends React.Component {
	render () {
		const { tierFilter = {} } = this.props.artistStore;
		let tierValue = _(tierFilter).values().first() || '';
		tierValue = tierValue.toUpperCase().replace(/\s/g, '_');

		if (tierValue == 'IN_REVIEW' && this.isActive('PENDING') != true) {
			tierValue = 'TIER_1';
		}
		
		return (
			<div>
				<div className="grid-x">
					<div className="cell auto">
						<nav>
							<ul className="menu horizontal artist-nav">
								<li>
									<NavLink
										data-ta="activeArtistsButton"
										isActive={ this.isActive('ALL') }
										to={ `/manage-artists/ALL/${tierValue}` }
									>
										All
									</NavLink>
								</li>
								<li>
									<NavLink
										data-ta="activeArtistsButton"
										isActive={ this.isActive('ACTIVE') }
										to={ `/manage-artists/ACTIVE/${tierValue}` }
									>
										Active Artists
									</NavLink>
								</li>
								<li>
									<NavLink
										isActive={ this.isActive('INACTIVE') }
										to={ `/manage-artists/INACTIVE/${tierValue}` }
									>
										Inactive Artists
									</NavLink>
								</li>
								<li>
									<NavLink
										isActive={ this.isActive('PENDING') }
										to={ `/manage-artists/PENDING/IN_REVIEW` }
									>
										Not Rated
									</NavLink>
								</li>
								<li>
									<NavLink
										isActive={ this.isActive('CANCELLED') }
										to={ `/manage-artists/CANCELLED/${tierValue}` }
									>
										Cancelled
									</NavLink>
								</li>
							</ul>
						</nav>
					</div>
				</div>
			</div>
		);
	}

	isActive (filterSlug) {
		return () => {
			const { statusFilter = {} } = this.props.artistStore;
			const isStatusFilterSelected = _(statusFilter).values().first() === filterSlug;

			return isStatusFilterSelected;
		};
	}
}

export default ArtistStatusFilter;
